<template>
    <div class="teach-resource-build">
        <div class="teach-resource-build-top">
            <div class="title">作业布置与作答分析</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teach-resource-build-box">
            <div class="region-panorama-board-top-filter">
                <!-- <div class="filter-btn" @click="filterSelect = 0" :class="filterSelect == 0 ? 'is-select' : ''">小学</div>
                <div class="filter-btn" @click="filterSelect = 1" :class="filterSelect == 1 ? 'is-select' : ''">初中</div>
                <div class="filter-btn" @click="filterSelect = 2" :class="filterSelect == 2 ? 'is-select' : ''">高中</div> -->
            </div>
            <div id="homeworkAnalysis" style="width:50%;height: 100%"></div>
            <div class="right-container">
                <div class="right-container-wrap">
                    <div class="subject-count-title">
                        <div class="subject-title" style="width: 40%">学科</div>
                        <div class="count-title" style="width: 30%">布置</div>
                        <div class="count-title" style="width: 30%">提交</div>
                    </div>
                    <template v-for="(item, index) in subjectMap" v-if="subjectMap.length > 0 && index < 6">
                        <div class="subject-count-name" v-if="index % 2 === 1" style="background-color: rgba(16, 34, 67, 0.5)">
                            <span class="subject-name" style="width: 40%">{{
                                item.subjectName
                            }}</span>
                            <span class="submit-count" style="width: 30%" :title="item.useNum  ">{{ item.useNum
                            }}</span>
                             <span class="submit-count" style="width: 30%" :title="item.useNum ">{{ item.submit
                            }}</span>
                        </div>
                        <div class="subject-count-name" v-else>
                            <span class="subject-name" style="width: 40%">{{
                                item.subjectName
                            }}</span>
                            <span class="submit-count" style="width: 30%" :title="item.useNum  ">{{ item.useNum
                            }}</span>
                             <span class="submit-count" style="width: 30%" :title="item.useNum ">{{ item.submit
                            }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
<script>
export default {
    name: 'homeworkAnalysis',
    data() {
        return {
            color: [
                { offset: 0, color: "#00FEFF" },
                { offset: 0.9, color: "#24C4DC" },
                { offset: 1, color: "#24C4DC" },
            ],
            filterSelect: 0,
            subjectMap: [{ subjectName: '语文', useNum: 15265,submit:254610}, { subjectName: '数学', useNum: 15265,submit:254610 }, { subjectName: '物理', useNum: 15265,submit:254610 }, { subjectName: '化学', useNum: 15265,submit:254610 }, { subjectName: '地理', useNum: 15265,submit:254610 }, { subjectName: '生物', useNum: 15265,submit:254610 },],
        }
    },
    methods: {
        /**
           * 初始化教师课堂行为柱状图
           */
        initChart() {

            const option = {
                legend: {
                    show: false,
                },
                radar: {
                    shape: 'circle',
                    nameGap: 5,  // 设置标签与图形的距离
                    splitArea: {
                        areaStyle: {
                            color: "#2783CD",
                            opacity: 0.2,
                            shadowColor: "#D2F7F9",
                            shadowBlur: 10,
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            width: 1,
                            color: "#2783CD",
                            opacity: 0.45,
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#708ACC",
                        },
                    },
                    indicator: [
                        { name: '语文', max: 6500 },
                        { name: '数学', max: 16000 },
                        { name: '物理', max: 30000 },
                        { name: '化学', max: 38000 },
                        { name: '地理', max: 52000 },
                        { name: '生物', max: 25000 }
                    ]
                },
                series: [
                    {
                        // name: 'Budget vs spending',
                        type: 'radar',
                        symbol: "none", //去掉边拐点
                        lineStyle: {
                            color: '#0F3C6E'  // 设置线条颜色为红色
                        },
                        areaStyle: {
                            color: '#0EFCFF'
                        },
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, this.color),
                                },
                            },
                        },
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 50000, 18000],
                                name: 'Allocated Budget'
                            }
                        ]
                    }
                ]
            };
            let dataChart = this.$echarts.init(document.getElementById('homeworkAnalysis'));
            dataChart.setOption(option);
            window.addEventListener('resize', function () {
                dataChart.resize();
            });
        }
    },
    mounted() {
        this.initChart()
    }
}
</script>
<style lang='scss' scoped>
.teach-resource-build {
    width: 100%;
    height: 250px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;

    // background: rgba(6,17,52,0.8);
    .teach-resource-build-top {
        position: relative;
        text-align: center;
        margin-bottom: 15px;

        .title {
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }

        .more {
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }

        .title-bg {
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .teach-resource-build-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: calc(100% - 55px);

        .region-panorama-board-top-filter {
            position: absolute;
            left: 20px;
            top: 5%;
            display: flex;
            align-items: center;
            background: rgba(31, 51, 141, 0.57);
            border-radius: 4px;

            .filter-btn {
                padding: 5px 8px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #C1ECFF;
                cursor: pointer;
            }

            .is-select {
                background: #2B7FFF;
                border-radius: 4px;
                color: #FFFFFF;
            }
        }

        .right-container {
            width: 50%;

            .right-container-wrap {
                .subject-count-title {
                    display: flex;
                    color: #6EA0D3;
                    background: rgba(16, 34, 67, 0.5);
                    padding:4px 0;
                }
                .subject-count-name{
                    display: flex;
                    color: #A1B6EB;
                    padding: 4px 0;
                }
            }
        }
    }
}

.top-left {
    position: absolute;
    top: 0;
    left: 0;
    width: 14px;
    height: 14px;
}

.top-right {
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
}

.left-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 14px;
    height: 14px;
}

.right-bottom {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 14px;
    height: 14px;
}</style>